// ---------------------------------------------------------------------------
// YouAreYou (uru) — Mode Context Types
//
// Separated from ModeContext.tsx to satisfy eslint-plugin-react-refresh,
// which requires files exporting React components to not also export
// non-component bindings. Pattern mirrors authTypes.ts / AuthContext.tsx.
// ---------------------------------------------------------------------------

import { createContext } from "react";

export type AppMode = "simple" | "advanced";

export interface ModeContextValue {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
  toggleMode: () => void;
}

export const ModeContext = createContext<ModeContextValue | null>(null);

export const MODE_STORAGE_KEY = "uru_app_mode";
